import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('mdjYGraphStore', Object.keys(state)),
	...mapGetters('mdjYGraphStore', Object.keys(getters)) 
};
export const serviceMethods = {
	...mapActions('mdjYGraphStore', Object.keys(actions)), 
	...mapMutations('mdjYGraphStore', Object.keys(mutations)) 
};
